import { render, staticRenderFns } from "./ProductFaqs.vue?vue&type=template&id=17881a68"
import script from "./ProductFaqs.vue?vue&type=script&lang=js"
export * from "./ProductFaqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports